<template>
  <div>
    <!-- pc -->
      			<div class="footer_inner">
      				<div class="footer_items1 mb_none">
      					<div class="xglj fl">
      						相关链接：
      					</div>
      	                <div class="select_nav select_nav_mr"  @click="footclick1" >
      	                    <p class="select_tit" :class="footListshow1 == true ? 'selected_p' : ''" >国家及各省交易中心</p>
      	                    <ul class="select_nav_ul"  :class="footListshow1 == true ? 'select_nav_ul_show' : ''" >
      	                            <li>
      	                                <a href='http://www.ggzy.gov.cn/' target="_blank">全国公共资源交易平台</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href='http://ggzyjy.sc.gov.cn/' target="_blank">四川公共资源交易平台</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href='http://www.jl.gov.cn/ggzy/' target="_blank">吉林公共资源交易信息网</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href='http://hljggzyjyw.gov.cn/' target="_blank">黑龙江公共资源交易网</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href='http://www.lnggzy.gov.cn/lnggzy/' target="_blank">辽宁公共资源交易平台</a>
      	                            </li>
		                

      	                            <li>
      	                               <a href='http://www.xzggzy.gov.cn:9090/' target="_blank">西藏公共资源交易信息网</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href='http://www.ynggzyxx.gov.cn/' target="_blank">云南公共资源交易平台</a>
      	                            </li>
		                

      	                    </ul>
      	                </div>
      	                <div class="select_nav select_nav_mr"  @click="footclick2">
      	                    <p class="select_tit" :class="footListshow2 == true ? 'selected_p' : ''">自治区各交易中心</p>
      	                    <ul class="select_nav_ul"  :class="footListshow2 == true ? 'select_nav_ul_show' : ''" >
      	                            <li>
      	                                <a href="http://222.74.200.108:8081/TPBidder/memberLogin" target="_blank" title="自治区工程项目招投标系统">自治区工程项目招投标系统</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://222.74.200.77:8090/devops/trade/welcome" target="_blank" title="自治区自然资源出让交易系统">自治区自然资源出让交易系统</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://39.104.85.103:7002/gp-auth-center/login" target="_blank" title="自治区政府采购交易系统">自治区政府采购交易系统</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.nmcqjy.com/" target="_blank" title="自治区产权交易中心">自治区产权交易中心</a>
      	                            </li>
		                

      	                    </ul>
      	                </div>
      	                <div class="select_nav" @click="footclick3">
      	                    <p class="select_tit"  :class="footListshow3 == true ? 'selected_p' : ''" >盟市交易机构</p>
      	                    <ul class="select_nav_ul"  :class="footListshow3 == true ? 'select_nav_ul_show' : ''" >

      	                            <li>
      	                                <a href="http://ggzy.huhhot.gov.cn/" target="_blank" title="呼和浩特市">呼和浩特市</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.btggzyjy.cn/" target="_blank" title="包头市">包头市</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.ordosggzyjy.org.cn" target="_blank" title="鄂尔多斯市">鄂尔多斯市</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.hlbeggzyjy.org.cn/" target="_blank" title="呼伦贝尔市">呼伦贝尔市</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.xmggzyjy.org.cn/" target="_blank" title="锡林郭勒盟">锡林郭勒盟</a>
      	                            </li>
		                

      	                            <li>
      	                                <a href="http://www.xamggzyjyzx.org.cn/xamggzy/" target="_blank" title="兴安盟">兴安盟</a>
      	                            </li>

  									<li>
  	    	                            <a href="http://www.whggzy.com/" target="_blank" title="乌海市">乌海市</a>
  	    	                        </li>
		                

  	    	                        <li>
  	    	                            <a href="http://ggzy.chifeng.gov.cn" target="_blank" title="赤峰市">赤峰市</a>
  	    	                        </li>

  									<li>
  		    	                        <a href="http://ggzy.wulanchabu.gov.cn/" target="_blank" title="乌兰察布市">乌兰察布市</a>
  		    	                    </li>

  									<li>
  		    	                            <a href="http://ggzy.tongliao.gov.cn/" target="_blank" title="通辽市">通辽市</a>
  		    	                    </li>
		                

  		    	                    <li>
  		    	                        <a href="http://zwzx.bynr.gov.cn/" target="_blank" title="巴彦淖尔市">巴彦淖尔市</a>
  		    	                    </li>

  									<li>
  			    	                    <a href="http://www.alsggzyjy.cn/website/zyjyzx/html/index.html" target="_blank" title="阿拉善盟">阿拉善盟</a>
  			    	                </li>

  									<li>
  		    	                        <a href="http://www.mzlggzy.org.cn/" target="_blank" title="满洲里市">满洲里市</a>
  		    	                    </li>
		                

  		    	                    <li>
  		    	                        <a href="http://www.elht.gov.cn/" target="_blank" title="二连浩特市">二连浩特市</a>
  		    	                    </li>

		                
      	                    </ul>
      	                </div>
      	                <div class="clearfix"></div>
      	            </div>
      	            <div class="foot_wrap" style="margin-left: 80px;">
      					<div class="foot_wrap_l fl">
      						<div class="foot_wrap_l_img fl">
      							<!-- <script type="text/javascript">document.write(unescape("%3Cspan id='_ideConac' %3E%3C/span%3E%3Cscript src='https://dcs.conac.cn/js/07/000/0000/60923115/CA070000000609231150004.js' type='text/javascript'%3E%3C/script%3E"));</script> -->
      						</div>
      						<div class="foot_wrap_l_wzsm fl">
      							<ul>
      								<li><a target="_blank" href="http://trs.nmsuny.com:6689/ggzyjyw/zwgk/jgjj/">关于我们</a></li>
      								<li><a target="_blank" href="http://trs.nmsuny.com:6689/ggzyjyw/wzdt/">网站地图</a></li>
      								<li><a target="_blank" href="http://trs.nmsuny.com:6689/ggzyjyw/hdjl_0/zxts_1164/">咨询投诉</a></li>
      							</ul>
      						</div>
      						<div class="foot_wrap_r_msg fl">
      							<p style="margin-right: 15px;">内蒙古自治区公共资源交易中心</p>
      							<p style="margin-right: 15px;"><a href="http://beian.miit.gov.cn">蒙ICP备05000248号</a></p>
      							<p>政府网站标识码：1500000082</p>
      							</br>
      							<p class="gaba" style="margin-right: 35px;"><img src="../assets/img/footer_jh.png" /><a  target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010202150862"  >蒙公网安备 15010202150746号</a></p>
      							<p>地址：内蒙古呼和浩特市赛罕区敕勒川大街6号</p>
      							</br>
      							<p style="margin-right: 40px;">电话：0471-5332686，0471-5332613，0471-5332667</p>
      							<p> 网站访问量：<span>22493640</span></p>
      						</div>
      						<div class="foot_wrap_r_ewm fl">
      							<div class="foot_wrap_r_ewm_wx fl" style="width: 70px;text-align: center;">
      								<img src="../assets/img/weixin.jpg"/>
      								<p>微信公众号</p>
      							</div>
      							<div class="foot_wrap_r_ewm_qg fl " style="width: 100px;text-align: center;">
      								<img src="../assets/img/ziyuan.png"/>
      								<p>全国公共资源交易</p>
      							</div>
      						</div>
      					</div>
                      </div>
      			</div>
			

    <!-- mobile -->
    <div class="mobile">
      <!-- <div class="row1">
        <span><a>政务微信</a></span>
        <span style="font-size: 10px">|</span>
        <span><a>客户端</a></span>
        <span style="font-size: 10px">|</span>
        <span><a>蒙速办</a></span>
      </div> -->
      <div class="row2">
        <div class="left">
          <a
            href="https://bszs.conac.cn/sitename?method=show&id=9461F6EEB08FC5CAE05310291AACD7D6"
            target="_blank"
          >
            <div class="logo_bottom"></div
          ></a>
        </div>
        <div class="right">
          <div class="aline">
            <a href="">主办单位：内蒙古自治区公共资源交易中心</a>
          </div>
          <!-- <div class="aline">
            <a href="">承办单位：内蒙古自治区政务服务局</a>
          </div> -->
          <div class="aline">
            <span><a target="_blank" href="http://beian.miit.gov.cn">蒙ICP备05000248号</a></span
            ><i></i
            ><span
              ><a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010202150862"
                target="_blank"
                >蒙公网安备 15010202150746号</a
              ></span
            >
          </div>
          <div class="aline">
            <a>政府网站标识码：1500000082</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-footer",
  components: {},
  props: {},
  data() {
    return {
      active: 0,
      isShow: false,
      footListshow1: false, //国家部委下拉列表隐藏
      footListshow2: false, //各省市区政府网站下拉列表隐藏
      footListshow3: false, //自治区部门网站下拉列表隐藏
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 底部链接
    footclick1: function () {
      this.footListshow1 = !this.footListshow1;
      this.footListshow2 = false;
      this.footListshow3 = false;
      this.footListshow4 = false;
    },
    footclick2: function () {
      this.footListshow2 = !this.footListshow2;
      this.footListshow1 = false;
      this.footListshow3 = false;
      this.footListshow4 = false;
    },
    footclick3: function () {
      this.footListshow3 = !this.footListshow3;
      this.footListshow1 = false;
      this.footListshow2 = false;
      this.footListshow4 = false;
    },
    show(e) {
      this.active = e;
      this.isShow = true;
    },
    unshow() {
      this.isShow = false;
      this.active = 0;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
@import '../assets/css/index.css';
/* .footer {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 250px;
  bottom: 0;
  background-image: url(../assets/img/footer.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
} */
@media screen and (min-width: 751px) {
  .mobile{display: none;}
}
// 移动端样式
@media screen and (max-width: 750px) {
  @w: 7.5vw;
  .footer_inner{display: none;}
  .wrap {
    display: none;
    // .header {
    //   width: 750px;
    //   height: 420px;
    //   background-image: url(../../assets/img/normal_search/header_bg.png);
    //   background-size: 100% 100%;
    // }
  }
  .footer{height: auto;}
  .mobile {
    width: 100%;
    height: 280 / @w;
    background-color: rgb(1, 82, 147);
    padding-top: 30 / @w;
    margin-top: 10 / @w;
    
    .row1 {
      width: 400 / @w;
      height: 30 / @w;
      margin: 0 auto;
      span {
        margin-right: 20 / @w;
        color: rgb(100, 160, 193);
        a {
          font-size: 30 / @w;
          line-height: 30 / @w;
          text-decoration: none;
          color: rgb(186, 206, 228);
        }
      }

      span:last-child {
        margin-right: 0;
      }
    }
    .row2 {
      width: 700 / @w;
      height: 150 / @w;
      margin: 0 auto;
      // margin-top: 30 / @w;
      .left {
        float: left;
        width: 60 / @w;
        height: 150 / @w;
        .logo_bottom {
          width: 80 / @w;
          height: 80 / @w;
          background-image: url("https://dcs.conac.cn/image/blue.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-top: 20 / @w;
          // margin-right: 35/@w;
        }
      }
      .right {
        float: right;
        height: 150 / @w;
        width: 580 / @w;

        .aline {
          float: left;
          width: 510 / @w;
          a {
            text-decoration: none;
            font-size: 20 / @w;
            color: rgb(186, 206, 228);
          }
          i {
            display: inline-block;
            width: 20 / @w;
            height: 20 / @w;
            margin-left: 5 / @w;
            margin-right: 5 / @w;
            background-image: url("../assets/img/gongan.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
</style>